import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { QuickActionsService } from '../services/quickActions.service'
import { setQuickActionButtons } from '../store/quickActions.actions'

export function* getQuickActionButtons() {
  const serviceId = yield select(getServiceIdSelector)
  const quickActionsService = new QuickActionsService(serviceId)
  try {
    const response = yield call([quickActionsService, quickActionsService.getQuickActionButtons])
    const { entity } = response
    yield put(setQuickActionButtons(entity))
  } catch (e) {
    yield put(throwPcrException(`getQuickActionButtons() error: ${e}`))
  }
}
export function* getQuickActionButtonsSaga() {
  yield takeLatest([QuickActionsConstants.SET_QUICK_ACTIONS], getQuickActionButtons)
}
